/** Cherto unit type key for the logged-in customer (member) id. */
export const CHERTO_USER_ID_UNIT_TYPE = 'user-id'

/**
 * Cherto unit type key for the Snowplow visitor id.
 * This is `resolvedTrackingId`: the stitched seed when one exists, otherwise
 * the anonymous domain user id. Experiments on this unit keep using that seed
 * id. `bucketingId` is only sent for Customer BK (`user-id`).
 */
export const CHERTO_DOMAIN_USER_ID_UNIT_TYPE = 'domain-userid'
